import {
	Box,
	Checkbox,
	CircularProgress,
	Divider,
	SelectChangeEvent,
	Typography,
} from '@mui/material';
import CustomButton from '@src/components/CustomButton/CustomButton';
import LabeledSelectField from '@src/components/CustomSelect/LabeledSelectField';
import LabeledTextField from '@src/components/CustomTextField/LabeledTextField';
import { ModalCloseIcon } from '@src/components/Icons';
import ImageThumnail from '@src/components/ImagePreview/ImageThumnail';
import DragDrop from '@src/components/ImageUploader/DragDrop';
import { IsMobileWidth, IsTabletWidth } from '@src/components/MediaQueryUtils';
import PageHeader from '@src/components/PageHeader/PageHeader';
import { CustomAlertType, Image } from '@src/interfaces/type';
import React, { useState } from 'react';
import styled from 'styled-components';
import { OrderView } from '..';
import ProductSummaryCard from './ProductSummaryCard';
import { ApplicationContext } from '@src/contexts/ApplicationContext';
import { AxiosError, AxiosResponse } from 'axios';
import { OrderProduct } from '../acceptDelivery';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	letter-spacing: 0.28px;
	width: 100%;
	height: 90vh;
	overflow: hidden;
	#mid {
		display: flex;
		flex-direction: column;
		gap: 14px;
		align-items: center;
		padding: 16px;
		width: 100%;
		overflow-y: auto;
		padding-top: 5px;
		padding-bottom: 5px;
		flex-grow: 1;

		/* Media query for smaller screens */
		@media (max-height: 660px) {
			/* height: calc(100vh - 70px);
			margin-bottom: 66px; */
			margin-bottom: 68px;
		}

		#product-details {
			display: flex;
			justify-content: space-between;
			align-items: center;
			color: var(--Gray-g-600, #7d7d7d);
			font-size: 13px;
			font-weight: 600;
			width: 100%;
			@media screen and (max-width: 768px) {
				flex-direction: column;
				align-items: flex-start;
				gap: 14px;
			}
		}
	}
`;

const StyledBottomBtnContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 14px;
	width: 100%;
	height: 68px;
	padding: 20px;
	background: var(--chat-header-bg);
	border: 1.5px solid var(--gray-color-light);
	z-index: 100;
	position: absolute;
	bottom: 0;
	flex-shrink: 0;
`;

interface ProductQualityCheckProps {
	windowDimensions: any;
	handleClose: any;
	setView: (data: OrderView) => void;
	setApiCall: (data: boolean) => void;
	products: any;
	cheeniOrderId: string;
	setAlert: (data: CustomAlertType) => void;
	displayCustomError: any;
}

const OrderApprovalSummary: React.FC<ProductQualityCheckProps> = ({
	windowDimensions,
	handleClose,
	setView,
	products,
	cheeniOrderId,
	setAlert,
	displayCustomError,
	setApiCall,
}) => {
	const { apiService }: any = React.useContext(ApplicationContext);
	const [product, setProduct] = useState({
		quantity: '',
		issue: '',
		comment: '',
	});
	//file-upload
	const [files, setFiles] = useState<File[]>([]);
	const [images, setImages] = useState<Image[]>([]);
	const [loading, setLoading] = useState(false);
	const isMobileWidth = IsMobileWidth();
	const handleChange = () => {};

	const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
		event.preventDefault();
		const filesData = event?.target?.files;
		let imageCount = images?.length + (filesData?.length || 0);
		let validFiles = [];
		let imagesData = [...images];

		if (imageCount <= 3) {
			if (filesData) {
			}
			setFiles([...files]);
			setImages(imagesData);
		} else {
			// displayError('Maximum of 3 images allowed');
		}
	};

	const handleFileDrop = async (event: React.DragEvent<HTMLDivElement>) => {
		event.preventDefault();
		const filesData = event.dataTransfer?.files;
		let imageCount = images?.length + (filesData?.length || 0);
		let validFiles = [];
		let imagesData = [...images];

		if (imageCount <= 3) {
			if (filesData) {
			}
			setFiles([...files]);
			setImages(imagesData);
		} else {
			// displayError('Maximum of 3 images allowed');
		}
	};

	const handleArrowBack = () => {
		setView('orderDetails');
	};

	const fieldsStyle1 = { width: '84vw', height: '36px' };
	const fieldsStyle2 = { width: '198px', height: '36px' };

	const confirmOrder = () => {
		setLoading(true);
		apiService?.confirmOrderProducts(
			(res: AxiosResponse) => {
				setAlert({ message: 'Order Products Updated Successfully', severity: 'success' });
				setView('');
				handleClose();
				setLoading(false);
				setApiCall(true);
			},
			(error: AxiosError) => {
				displayCustomError('Something went wrong!');
				setLoading(false);
			},
			cheeniOrderId
		);
	};
	return (
		<StyledContainer>
			{isMobileWidth ? (
				<>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'flex-start',
							alignItems: 'flex-start',
							padding: '20px 10px 10px 10px',
							flexShrink: 0,
							width: '100%',
						}}
					>
						<p
							style={{
								color: '#5C5C5C',
								fontFamily: 'Poppins',
								fontSize: '16px',
								fontWeight: 400,
							}}
						>
							Request For Supplier
						</p>
					</Box>
					<Divider style={{ width: '100%' }} />
				</>
			) : (
				<Box
					display="flex"
					justifyContent="space-between"
					alignItems="center"
					px={2}
					width="100%"
					height="56px"
				>
					<Typography variant="body1">Request For Supplier</Typography>

					<div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
						{windowDimensions?.width >= 800 ? (
							<CustomButton
								type="submit"
								title={
									loading ? (
										<CircularProgress size={20} style={{ color: 'var(--default-text-color)' }} />
									) : (
										'Confirm'
									)
								}
								handleClick={confirmOrder}
								disabled={loading}
								styles={{
									width: '132px',
									height: '36px',
								}}
							/>
						) : null}
						<Box sx={{ cursor: 'pointer' }} onClick={handleClose}>
							<ModalCloseIcon />
						</Box>
					</div>
				</Box>
			)}
			<Divider style={{ width: '100%' }} />
			<div id="mid">
				{products?.map((product: any) => {
					return <ProductSummaryCard product={product} />;
				})}
			</div>
			{isMobileWidth ? (
				<StyledBottomBtnContainer>
					<CustomButton
						type="submit"
						title={
							loading ? (
								<CircularProgress size={20} style={{ color: 'var(--default-text-color)' }} />
							) : (
								'Confirm'
							)
						}
						handleClick={confirmOrder}
						disabled={loading}
						styles={{
							width: '328px',
							height: '36px',
						}}
					/>
				</StyledBottomBtnContainer>
			) : null}
		</StyledContainer>
	);
};

export default OrderApprovalSummary;
